<template>
    <router-link :to="data.route" class="category">
        <div class="category__header">
            <template v-if="data.icon !== null">
              <img :src="data.icon" :alt="data.title">
            </template>
            <template v-else>
              <i class="icon-torah"></i>
            </template>
            <span class="count">{{ $tc('items', data.count) }}</span>
        </div>
        <div class="category__content">
            <h4 class="title">{{data.title}}</h4>
            <h4 class="title">{{data.translation}}</h4>
            <p>
                {{data.info}}
            </p>
        </div>
    </router-link>
</template>

<script>
  export default {
    name: 'Category',

    props: {
      data: Object
    }
  };
</script>
